<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/w6RxFh/tc-custom/9781955835206.jpg?1703821040103" alt="This image is the cover for the book Seeing Things"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seeing Things
      </h1>
      <p class="bookDescription body article font2">
        <b>The late Jesuit theologian shares how the imagination “animates our aspirations, our service, and a deeper connection to God and to one another” (John J. DeGioia, President of Georgetown University).</b><br/><br/>“This book is a pedagogical memoir enabling the reader to enter the late Jesuit Professor James Walsh’s Georgetown University classroom in various moments. Rev. Walsh considered imagination central to lived religion in the broadest sense, namely the vision of the prophet, the exegesis of the theologian, the teaching of the professor, the preaching of the pastor, and the experiences of the student, the seeker and the believer. And [<i>Seeing Things</i>] stands as an eloquent and accessible mini-course in the place of imagination in moral theology, as well as the spiritual testament of a caring and loving teacher, healer, and friend.” —David Goldfrank, Professor of History, Georgetown University <br/><br/>“This study is a fascinating presentation of how we imagine ourselves and the context of the world around us. Father Walsh’s long-standing commitment to helping his students and colleagues understand both elevates the text to a unique level of contemplation.” —Ronald Jonson, Professor Emeritus of History, Georgetown University
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        James P.M. Walsh
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?065c182c